export const MouthguardTextFonts = [
	{font: 'Bebas Neue'},
	{font: 'Pacifico'},
	{font: 'Saira Stencil One'},
	{font: 'Russo One'},
	{font: 'Vampiro One'},
	{font: 'Helvetica'},
	{font: 'Ultra'},
] as const;